module.exports = "/_next/static/images/HCGO_Website-Banner-b3ea278ac48062b4c7c43dd583b627ff.jpg";